const trimAllSpaces = input => input?.replace(/ /g, '');
export default trimAllSpaces;